import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=d819004a"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports